import { Box, Flex, Heading, type BoxProps, useColorModeValue } from '@chakra-ui/react';
import type { ReactNode } from 'react';

export function TeamDetailSectionCard(
  props: { title: string; headerExtra?: ReactNode; children: ReactNode } & BoxProps,
) {
  const bg = useColorModeValue('gray.50', 'gray.700');
  const { title, headerExtra, children, ...rest } = props;

  return (
    <Box bg={bg} borderRadius={16} px={4} py={3} w='full' {...rest}>
      <Flex align='center' justify='space-between' gap={3} mb={3}>
        <Heading size='sm' textAlign='left'>
          {title}
        </Heading>
        {headerExtra}
      </Flex>
      {children}
    </Box>
  );
}
